import React from "react";
import "./CommerceDisclosures.css";

const CommerceDisclosures = () => {
  return (
    <div className="commerce-page">
      <div className="commerce-container">
        <h1>Commerce Disclosures</h1>
        <p className="effective-date">Effective Date: April 1, 2025</p>

        <section className="commerce-section">
          <h2>1. Business Information</h2>
          <p>
            Diviti Adora Infrared & Red Light Studio ("we", "us", or "our") is a
            provider of infrared sauna sessions, red light therapy treatments,
            and related wellness services. Our business is committed to
            transparency in all commercial transactions.
          </p>
        </section>

        <section className="commerce-section">
          <h2>2. Service and Product Descriptions</h2>
          <p>
            <strong>Infrared Sauna Sessions:</strong> Detailed descriptions of
            session durations, temperatures, and any health or wellness benefits
            are provided on our website and in our studio.
          </p>
          <p>
            <strong>Red Light Therapy Treatments:</strong> Information on
            treatment duration, expected outcomes, and any necessary precautions
            is made available to help you make informed decisions.
          </p>
          <p>
            <strong>Additional Offerings:</strong> Any supplementary products
            (e.g., wellness accessories, skincare products) are described with
            specifications and usage guidelines.
          </p>
        </section>

        <section className="commerce-section">
          <h2>3. Pricing and Payment Terms</h2>
          <p>
            <strong>Pricing:</strong> All prices for our services and products
            are displayed clearly on our website and at our studio. Prices are
            subject to change without prior notice, but any confirmed booking or
            purchase will be honored at the price in effect at the time of the
            transaction.
          </p>
          <p>
            <strong>Payment Methods:</strong> We accept major credit cards,
            debit cards, and other payment methods as indicated on our website.
            Payment is required in full at the time of purchase or booking.
          </p>
          <p>
            <strong>Taxes and Fees:</strong> All applicable taxes and fees are
            included in the displayed price, unless otherwise noted.
          </p>
        </section>

        <section className="commerce-section">
          <h2>4. Refund, Cancellation, and Rescheduling Policies</h2>
          <p>
            <strong>Refund Policy:</strong> Refund eligibility for services and
            products is outlined on our website. In general, refunds may be
            available under specific conditions, such as cancellations made
            within the allowable time frame or in the event of service
            cancellations by us.
          </p>
          <p>
            <strong>Cancellation Policy:</strong> Clients are advised to review
            our cancellation terms at the time of booking. Cancellation fees or
            penalties may apply if notice is not provided within the stipulated
            period.
          </p>
          <p>
            <strong>Rescheduling:</strong> Where possible, sessions may be
            rescheduled. Rescheduling is subject to availability and may require
            a fee or adjustment in service pricing.
          </p>
        </section>

        <section className="commerce-section">
          <h2>5. Order Processing and Service Delivery</h2>
          <p>
            <strong>Booking and Confirmation:</strong> Once you make a booking
            or purchase, you will receive an order confirmation via email. This
            confirmation serves as your receipt and includes details of the
            service, session timings, and any special instructions.
          </p>
          <p>
            <strong>Service Delivery:</strong> Our team is committed to
            delivering the highest quality of service. In the event of any
            disruptions or delays, we will notify you promptly and offer
            alternative arrangements.
          </p>
        </section>

        <section className="commerce-section">
          <h2>6. Third-Party Services and Affiliations</h2>
          <p>
            <strong>Third-Party Providers:</strong> For payment processing,
            scheduling, or other services, we may work with third-party
            providers. These providers are bound by their own privacy and
            commerce policies, which you should review separately if applicable.
          </p>
          <p>
            <strong>Affiliate Disclosures:</strong> Should any products or
            services be offered through affiliate partnerships, such
            affiliations will be disclosed, and any applicable commission
            arrangements will be clearly noted.
          </p>
        </section>

        <section className="commerce-section">
          <h2>7. Disclaimers and Health Notices</h2>
          <p>
            <strong>Wellness Disclaimer:</strong> The services provided by
            Diviti Adora Infrared & Red Light Studio are intended for wellness
            and relaxation purposes only. They are not intended to diagnose,
            treat, cure, or prevent any medical condition. Always consult with a
            healthcare professional before starting any new treatment.
          </p>
          <p>
            <strong>Results Disclaimer:</strong> While many clients report
            positive outcomes from our services, individual results may vary. We
            do not guarantee any specific results, and testimonials are not
            indicative of future performance.
          </p>
          <p>
            <strong>Risk Acknowledgment:</strong> By engaging in our services,
            you acknowledge the inherent risks associated with infrared and red
            light therapies and agree to use our services at your own risk.
          </p>
        </section>

        <section className="commerce-section">
          <h2>8. Amendments to Commerce Disclosures</h2>
          <p>
            We reserve the right to update or modify these Commerce Disclosures
            at any time. Any changes will be effective immediately upon posting
            on our website, and your continued use of our services signifies
            your acceptance of these changes.
          </p>
        </section>

        <section className="commerce-section">
          <h2>9. Contact Information</h2>
          <p>
            If you have any questions or concerns regarding these Commerce
            Disclosures, please contact us at:
          </p>
          <address>
            Diviti Adora Infrared & Red Light Studio
            <br />
            1930 E Tangerine Rd
            <br />
            Suite 100
            <br />
            Oro Valley, AZ 85737
            <br />
            Email:{" "}
            <a href="mailto:info@divitiadora.com">info@divitiadora.com</a>
          </address>
        </section>
      </div>
    </div>
  );
};

export default CommerceDisclosures;
